export default {
    sentryDSN: '', // https://vimeo.com/899367471
    debug: false,
    trackingDebug: false,
    pageInEditMode: !!document.querySelector('.page-edit-mode'),
    brightcove: {
        accountID: '',
        playerId: '',
    },
    breakpoint: {
        small: '568',
        medium: '767',
        large: '1024',
        xLarge: '1280',
    },
    message: {
        error: 'Something has gone quite wrong, please try to refresh your browser or contact us.',
        success: 'Thanks!',
    },
}
